import {
    getEditedImageServerlessUrlWorkflow,
    getUpscaledImageServerlessUrlWorkflow,
    getSimilarImageServerlessUrlWorkflow,
    getMatchingImageServerlessUrlWorkflow,
    getFittingImageServerlessUrlWorkflow,
    getImageWithNoBackgroundServerlessUrlWorkflow,
    getEnhancedImageServerlessUrlWorkflow,
    getLogoMediaObjectServerlessUrl,
    getLogoImagesServerlessUrlWorkFlow
} from '../constants'
import type {UserRequestInfo, ExecutionIdToMappedId} from '@wix/document-services-types'
import {postForMedia} from '../utils'

export interface ImagesRequestBody<T> {
    images: Record<string, T>
    userRequestInfo?: UserRequestInfo
}

export interface CommonImageFetchParams {
    userImage: string
    height_RunwareFlux: string
    width_RunwareFlux: string
}

export interface MatchImageToPageParams extends CommonImageFetchParams {
    Site_Description: string
}

export interface RemoveImageBackgroundParams {
    imageUrl: string
}

export interface EditImageParams extends CommonImageFetchParams {
    editRequest: string
}

export interface UpscaleImageParams {
    imageUrl: string
}

export interface LogoRequestBody<T> {
    logos: Record<string, T>
    userRequestInfo?: UserRequestInfo
}

export interface EditLogoParams {
    color_palette: Record<string, string>
    header_bg: string
    logo_url: string
    edit_request: string
    Business_Name: string
    Industry_Term: string
}

export interface LogoRequestParams {
    Business_Name: string
    Font: string
    Industry_Term: string
    Site_Description: string
    color_palette: Record<string, string>
    header_bg: string
    user_Request: string
    userRequestInfo: UserRequestInfo | undefined
}

export const fetchSimilarImageUrlsWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<CommonImageFetchParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getSimilarImageServerlessUrlWorkflow, requestBody)

export const fetchMatchingImagesWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<MatchImageToPageParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getMatchingImageServerlessUrlWorkflow, requestBody)

export const fetchFittingImagesWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<CommonImageFetchParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getFittingImageServerlessUrlWorkflow, requestBody)

export const fetchImagesWithNoBackgroundWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<RemoveImageBackgroundParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getImageWithNoBackgroundServerlessUrlWorkflow, requestBody)

export const fetchEditedImagesWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<EditImageParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getEditedImageServerlessUrlWorkflow, requestBody)

export const fetchUpscaledImagesWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<UpscaleImageParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getUpscaledImageServerlessUrlWorkflow, requestBody)

export const fetchEnhancedImagesWorkflow = async (
    serverFacade: any,
    requestBody: ImagesRequestBody<UpscaleImageParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getEnhancedImageServerlessUrlWorkflow, requestBody)

export const fetchLogoMediaObject = async (serverFacade: any, requestBody: LogoRequestParams): Promise<string> =>
    postForMedia<string>(serverFacade, getLogoMediaObjectServerlessUrl, requestBody)

export const fetchEditLogosWorkFlow = async (
    serverFacade: any,
    requestBody: LogoRequestBody<EditLogoParams>
): Promise<ExecutionIdToMappedId> =>
    postForMedia<ExecutionIdToMappedId>(serverFacade, getLogoImagesServerlessUrlWorkFlow, requestBody)
